import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Accordion from "react-bootstrap/Accordion";
import "./FAQ.css";

export default function BusinessHub(props) {
  return (
    <div>
      <Container>
        <Row>
          <Col className="faq-first-col">
            <h2 style={{ color: props.titleColor, fontSize: props.titleSize }}>
              {props.iconTitle}
              {props.titleContent}
            </h2>
          </Col>
        </Row>
      </Container>
      <Container>
        <Accordion defaultActiveKey="0">
          {props.questionsContent.map((question) => (
            <Accordion.Item eventKey={question.id} key={question.id}>
              <Accordion.Header>{question.title}</Accordion.Header>
              <Accordion.Body>{question.answer}</Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </Container>
    </div>
  );
}
